import React, { Fragment, useState, useEffect, useRef } from 'react';
import { SketchPicker } from "react-color";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { Col, Row } from "react-bootstrap";
import {
    Card,
    CardBody,
    Container
} from "reactstrap";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import cx from "classnames";
import CommonHeaderContent from '../../Common/CommonHeaderContent';
import { dashboardSortList, defaultPrimaryCardStyles, graphChartSampleData } from './Constants';
import CardPanel from './CardPanel';
import { getFormNameandLabel, getGraphChartContent, populateFormDetails, prepareSearchConditionComponent, randstr } from '../../Common/Appcommon';
import SearchPanel from '../Search/SearchPanel';
import { faFloppyDisk } from '@fortawesome/free-solid-svg-icons';
import requestApiService from '../../services/requestApi.service';
import GraphConfigForm from './GraphConfigForm';

const GraphChartConfig = (props) => {
    const buttonClickRef = useRef(null);
    let { isModalOpen, closeModal, changeChartStyle, chartType, selectedFolder, chartId, isClone } = props;
    let selectedChartInfo = graphChartSampleData[chartType];
    const [chartContent, setChartContent] = useState(getGraphChartContent(selectedChartInfo, 0));
    const [formData, setFormData] = useState({});
    const [selectedForm, setSelectedForm] = useState({});
    const [selectedMetrics, setSelectedMetrics] = useState({});
    const [formList, setFormList] = useState([]);
    const [formDetail, setFormDetail] = useState([]);
    const [summaryFields, setSummaryFields] = useState([]);
    const [searchComponents, setSearchComponents] = useState({});
    const [fieldList, setFieldList] = useState([]);
    const [selectedField, setSelectedField] = useState([]);
    const [sortBy, setSortBy] = useState(0);

    let searchActionCB = false;
    let formSaveActionCB = false;
    useEffect(() => {
        (async () => {
            if (chartId !== "") {
                setSearchComponents([]);
                await getDashboardDetails();
            } else {
                setSearchComponents([]);
                setFormDetail([]);
            }
            await getFormNameList();

        })();
        return () => {
            // this now gets called when the component unmounts
        };

    }, [chartId]);

    const getDashboardDetails = async () => {
        let params = {
            "ENTITY": "DashBoard",
            "OPERATION": "FETCH_NEW_GRAPH_DB_DETAILS",
            "chartId": chartId,
        }
        let res = await requestApiService.processServerRequest(params);
        if (res.issuccess) {
            let ddata = res.data;
            if (ddata.length > 0) {
                await prepareGraphDashboardData(ddata[0]);
            }
        }
    }

    const prepareGraphDashboardData = async (data) => {
        let dbName = data['name'];
        let formname = data['f1formname'];
        let f1fieldname = data['f1fieldname'];
        let f2fieldname = data['f2fieldname'];
        let sortby = parseInt(data['f2order']);
        let conditionstr = data['data_condition'];
        let chartType = data['graph_type;']
        let tmpFormData = {};
        tmpFormData['db_name'] = isClone ? "" : dbName;

        setSortBy(sortby);
        setFormData(tmpFormData);
        setFormDetail([]);
        let details = await populateFormDetails(formname);
        if (details.length > 0) {
            let scomponents = await prepareSearchConditionComponent(conditionstr, details);
            let fdetail = details[0];
            let formLabel = fdetail[2];
            let form = { 'value': formname, 'label': formLabel };
            await constructSummaryFieldList(details, f2fieldname);
            await constructFieldList(details, f1fieldname);
            setSelectedForm(form);
            setSearchComponents(scomponents);
            setFormDetail(details);
        }

    }

    const getFormNameList = async () => {

        let isEnabledList = {
            "isAddonEnabled": true,
            "isWsappEnabled": false,
            "isProfileEnabled": true,
            "type": "Workflow",
            "isContactRef": false,
            "isMenuEnabledOnly": true,
        };

        let response = await getFormNameandLabel(isEnabledList);
        if (response.issuccess) {
            let data = response.data;
            setFormList(data);
        }
    }

    const saveDashboardConfiguration = () => {
        buttonClickRef.current.click();
    }

    const constructFieldList = async(details, defaultField) => {
        let fieldDetails = details[1];
        let flist = [];
        let dfield = {};
        fieldDetails.map((field, index) => {
            let fieldType = field[4];
            let fieldName = field[2];
            let fieldLabel = field[3];
            if (fieldType !== "reference_entityid" && fieldType !== "reference_group" && fieldType !== "form_history" && fieldType !== "form_entityid" && fieldType !== "Date_Time" && fieldType !== "Date_Time_Text" && fieldType !== "subtable" && fieldType !== "Currency" && fieldType !== "Text Area") {
                let listvalue = { value: fieldName, label: fieldLabel };
                if (fieldName === defaultField) {
                    dfield = listvalue;
                }
                flist.push(listvalue)
            }
        });
        setSelectedField(dfield);
        setFieldList(flist);
    }

    const constructSummaryFieldList = async (details, defaultSummary = "") => {
        let fieldDetails = details[1];
        let summaryList = [];
        summaryList.push({ value: "Record_Count", label: "Record Count" })
        let defaultSum = summaryList[0];
        fieldDetails.map((field, index) => {
            let fieldType = field[4];
            let fieldName = field[2];
            let fieldLabel = field[3];
            if (fieldType === "Currency") {
                let listvalue = { value: fieldName, label: "Sum of " + fieldLabel };
                if (fieldName === defaultSummary) {
                    defaultSum = listvalue;
                }
                summaryList.push(listvalue)
            }
        });
        setSelectedMetrics(defaultSum);
        setSummaryFields(summaryList);
    }


    const onFormChange = async (details) => {
        setFormDetail([]);
        setFormDetail(details);
    }

    const searchClickCB = async (callback) => {
        searchActionCB = callback;
    }


    const formSaveClickCB = async (callback) => {
        formSaveActionCB = callback;
    }

    const submitForm = async () => {
        let isValidSearch = await searchActionCB("validateInput");
        if (!isValidSearch) {
            let searchString = await searchActionCB("getSearchString", {
                modeOfSearch: "AND"
            });
            if (searchString === "") {
                return;
            }
            let saveFormData = await formSaveActionCB();
            //saveFormData = formData;
            let fdetail = formDetail[0];
            let modulename = fdetail[0];
            saveFormData['folder'] = selectedFolder;
            saveFormData['searchString'] = searchString;
            //saveFormData['form'] = selectedForm;
            saveFormData['module'] = modulename;
            //saveFormData['metric'] = selectedMetrics;
            saveFormData['chartType'] = chartType;
            //saveFormData['field'] = selectedField;
            saveFormData['dbtype'] = selectedChartInfo['dbtype'];
            saveFormData['type'] = selectedChartInfo['type'];
            let key = randstr("graph_") + "##";
            saveFormData['layoutkey'] = key;
            //saveFormData['sort'] = sortBy;
            let params = {
                "ENTITY": "DashBoard",
                "OPERATION": chartId === "" || isClone ? "SAVE_GRAPH" : "UPDATE_GRAPH",
                "DATA": saveFormData,
                "chartId": isClone ? "" : chartId,
            }
            let res = await requestApiService.processServerRequest(params);
            if (res.issuccess) {
                onCloseCurrentModal(null, true);
            }
        }
    }

    const onCloseCurrentModal = (e, isRefresh = false) => {
        closeModal(isRefresh);
        /*setFormData({});
        setSelectedForm({});
        setSelectedMetrics({});*/
    }

    const onInputChange = async (e) => {
        let name = e.target.name;
        let value = e.target.value;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    }

    const { register, handleSubmit: handleActionFormSubmit, control, formState: { errors }, getValues } = useForm();
    return (
        <Modal isOpen={isModalOpen} className={"config-chart-modal le-modal-lg campaign-modal"}>
            <ModalBody>
                <Fragment>
                    <CommonHeaderContent
                        isModal={true}
                        closeModal={onCloseCurrentModal}
                        buttonTxt={"Save"}
                        buttonAction={saveDashboardConfiguration}
                        buttonIcon={faFloppyDisk}
                        buttonOutline={'success'}
                        headerTitle={"Add Chart"}
                        isClassNeeded={false}
                        mainContent={
                            <div className='pd-config-container'>
                                <div className='d-flex-alone'>
                                    <Row>
                                        <Col md="4" className='pd-panel-preview text-center'>
                                            {chartContent}
                                            <a className="cursor-pointer change-style-btn" onClick={(e) => { changeChartStyle(chartType) }}>Change Style</a>

                                        </Col>
                                        <Col md="8" className='pd-panel-config'>
                                            <div className='config-container'>
                                                <span className='config-title f18'>
                                                    Component
                                                </span>
                                                <div className='dashboard-section mt-3'>
                                                    <form id="config-form" name="primary-db" onSubmit={handleActionFormSubmit(submitForm)}>
                                                        <div className='form-conatiner'>
                                                            <GraphConfigForm 
                                                                key={"config-form-"}
                                                                control={control}
                                                                errors={errors}
                                                                preFormData={formData}
                                                                preFormDetail={formDetail}
                                                                preFormList={formList}
                                                                preSelectedForm={selectedForm}
                                                                preSelectedSummary={selectedMetrics}
                                                                preSummaryList={summaryFields}
                                                                preFieldList={fieldList}
                                                                preSortBy={sortBy}
                                                                preField={selectedField}
                                                                onSearchClickRegister={formSaveClickCB}
                                                                onFormChange={onFormChange}
                                                            />
                                                            {formDetail.length > 0 && <div className={cx('input-section mt-3')}>
                                                                <label className={'workflow-lbl d-flex-alone form-label'} htmlFor="condition">Criteria Filter</label>
                                                                <SearchPanel
                                                                    key={randstr('graph_')}
                                                                    fieldDetails={formDetail[1]}
                                                                    onSearchClickRegister={searchClickCB}
                                                                    preSearchComponents={searchComponents}
                                                                    forceFilter={true}
                                                                    filterType={"trigger"}
                                                                    searchStringType={"form"}
                                                                    actionType={"user"}
                                                                />
                                                            </div>
                                                            }
                                                            <div>
                                                                <span className="hide">
                                                                    <button ref={buttonClickRef} type="submit">
                                                                        <span>Save</span>
                                                                    </button>
                                                                </span>
                                                            </div>

                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        } />
                </Fragment>
            </ModalBody>
        </Modal>
    )
}

export default GraphChartConfig;